window.addEventListener('DOMContentLoaded', event => {
  let root = document.body.parentNode;
  root.classList.remove('no-js');
  root.classList.add('js');
});
